import {
  WbAvatar,
  WbEntityRefLink,
  WbLink,
} from '@agilelab/plugin-wb-platform';
import { UserEntity } from '@mainstage/catalog-model';
import {
  Box,
  createStyles,
  Grid,
  makeStyles,
  Theme,
  Typography,
} from '@material-ui/core';

const useStyles = makeStyles<Theme>(
  (theme: Theme) =>
    createStyles({
      avatar: {
        position: 'absolute',
        top: '-2rem',
      },
      card: {
        border: `1px solid ${theme.palette.divider}`,
        boxShadow: theme.shadows[0],
        borderRadius: '4px',
        overflow: 'visible',
        position: 'relative',
        margin: theme.spacing(4, 1, 1),
        flex: '1',
        minWidth: '0px',
      },
      email: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        display: 'inline-block',
        maxWidth: '100%',
        '&:hover': {
          overflow: 'visible',
          whiteSpace: 'normal',
        },
      },
    }),
  { name: 'MemberComponent' },
);

export function MemberComponent(props: { member: UserEntity }) {
  const {
    metadata: { name: metaName, description },
    spec: { profile },
  } = props.member;
  const displayName = profile?.displayName ?? metaName;
  const classes = useStyles();

  const entity = {
    kind: props.member.kind.toLocaleLowerCase('en-US'),
    namespace: props.member.metadata.namespace,
    name: metaName,
  };

  return (
    <Grid item container xs={12} sm={6} md={4} xl={2}>
      <Box className={classes.card}>
        <Box
          display="flex"
          flexDirection="column"
          m={3}
          alignItems="center"
          justifyContent="center"
        >
          <WbAvatar
            displayName={displayName}
            picture={profile?.picture}
            classes={{
              avatar: classes.avatar,
            }}
          />
          <Box
            pt={2}
            sx={{
              maxWidth: '100%',
            }}
            textAlign="center"
          >
            <Typography variant="h5">
              <WbEntityRefLink entityRef={entity} title={displayName} />
            </Typography>
            {profile?.email && (
              <WbLink className={classes.email} to={`mailto:${profile.email}`}>
                {profile.email}
              </WbLink>
            )}
            {description && (
              <Typography variant="subtitle2">{description}</Typography>
            )}
          </Box>
        </Box>
      </Box>
    </Grid>
  );
}
